module.exports = __webpack_public_path__ + "files/54119cac29c942530a870466c7451ff9.png";